module.exports = __webpack_public_path__ + "static/media/smstocontrol2.cfdff0b1.png";